import { useTheme } from '@mui/material';

import { MenuIconProps } from './menu-icon-props.interface';

export const NewsMenuIcon = ({ stroke, filled, ...props }: MenuIconProps) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return filled ? (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2471 4.00621C20.3357 3.71041 21.4501 4.52733 21.4502 5.69664V18.3021C21.4498 19.5492 20.1814 20.3969 19.0293 19.9193L12.9219 17.3861C12.5387 18.6935 11.3317 19.6486 9.90039 19.6488C8.16072 19.6488 6.75 18.2381 6.75 16.4984V15.4496H4.2998C3.33363 15.4494 2.55014 14.6657 2.5498 13.6996V10.2992C2.55002 9.33294 3.33355 8.54931 4.2998 8.54917H8.20117C8.23372 8.54911 8.26678 8.54303 8.29688 8.53062L19.0293 4.08042L19.2471 4.00621ZM8.25 16.4984C8.25 17.4096 8.98914 18.1488 9.90039 18.1488C10.7067 18.1486 11.3759 17.5697 11.5195 16.805L8.29688 15.4691C8.2818 15.4629 8.26605 15.4578 8.25 15.4544V16.4984Z"
        fill={strokeColor}
      />
    </svg>
  ) : (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.50005 14.7002V16.5002C7.50005 17.8257 8.57457 18.9002 9.90005 18.9002C11.2255 18.9002 12.3 17.8257 12.3 16.5002V16.2421M8.58396 9.22394L19.317 4.77364C19.9755 4.50061 20.7 4.98455 20.7 5.69738V18.303C20.7 19.0158 19.9755 19.4998 19.317 19.2268L8.58396 14.7765C8.46255 14.7261 8.33239 14.7002 8.20095 14.7002H4.30005C3.74776 14.7002 3.30005 14.2525 3.30005 13.7002V10.3002C3.30005 9.74791 3.74776 9.3002 4.30005 9.3002H8.20095C8.33239 9.3002 8.46254 9.27428 8.58396 9.22394Z"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </svg>
  );
};
